import { SCALE_TYPES } from '../../../../utils/scaleConfig';

export const HEADER_TEXT = {
    title: "Scores across the board",
    description: 'Mean score by category and stakeholder group, shaded by distance from the row benchmark (All but Self).'
}

// Legend for each rating scale, shown in the "How to read the ratings"
// collapse and picked by the org's scaleType. `tone` drives the red/green
// styling. The 4-point labels are the answer options those surveys use; they
// carry no % range, so the legend only prints one when it's there.
export const RATINGS_LEGEND = {
    heading: 'How to read the ratings',
    byScale: {
        [SCALE_TYPES.SIX_POINT]: {
            subheading: '6-point scale · scores ≥ 4 are favorable',
            footnote: "Scores 1–2 = Unfavorable · Scores 3–6 = Favorable. The heatmap shades cells around this threshold.",
            scale: [
                { value: 1, label: 'Almost Never', range: '0–10%', tone: 'unfavorable' },
                { value: 2, label: 'Rarely', range: '10–30%', tone: 'unfavorable' },
                { value: 3, label: 'Occasionally', range: '30–50%', tone: 'favorable' },
                { value: 4, label: 'Sometimes', range: '50–70%', tone: 'favorable' },
                { value: 5, label: 'Usually', range: '70–90%', tone: 'favorable' },
                { value: 6, label: 'Almost Always', range: '90–100%', tone: 'favorable' },
            ],
        },
        [SCALE_TYPES.FOUR_POINT]: {
            subheading: '4-point scale · scores ≥ 3 are favorable',
            footnote: "Scores 1–2 = Unfavorable · Scores 3–4 = Favorable. The heatmap shades cells around this threshold.",
            scale: [
                { value: 1, label: 'Rarely', tone: 'unfavorable' },
                { value: 2, label: 'Not Often Enough', tone: 'unfavorable' },
                { value: 3, label: 'Often', tone: 'favorable' },
                { value: 4, label: 'Almost Always', tone: 'favorable' },
            ],
        },
    },
}

// Compact key strip shown under the Heatmap description, explaining the cell
// shading, the favorable-threshold marker, the critical skill star, and row
// expansion.
export const HEATMAP_KEY = {
    shading: 'Shaded by distance from benchmark (All but Self) — red = below, green = above',
    threshold: (favorableMin) => `Below favorable threshold (< ${favorableMin})`,
    critical: 'Critical skill (top-ranked by stakeholders)',
    expand: 'Click a category to expand.',
}